export default __webpack_public_path__ + "static/0112-9794831062bd2c19e67d00a153f39dc5.png";